export default "__VITE_ASSET__D9o$u_sj__"